import React, { useState } from "react";
import RevShareModal from "../../common/overrides/RevShareModal";
import { ACCEPT_HOUR_UTILIZATION_REQUEST_SUCCESS } from "../../../redux/actions/ActionTypes";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import DatePicker from "../../common/forms/DatePicker";
import moment from "moment";

export default function AcceptRequestModal(props) {
  const [date, setDate] = useState();

  return (
    <RevShareModal
      api={ACCEPT_HOUR_UTILIZATION_REQUEST_SUCCESS}
      buttonText="Accept"
      buttonVariant="success"
      modalSize="sm"
      selfClosing
      title="Accept Request"
      yesButtonClickedText="Accepting"
      yesButtonOnClick={() => props.accept(props.request.id, moment(date).format())}
      yesButtonText="Accept"
      yesButtonVariant="success"
    >
      <p>Are you sure you want to accept this RevShare request?</p>
      <Table>
        <thead>
          <tr>
            <th>Consultant</th>
            <th>Hours</th>
            <th>Rate</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{props.request.consultantName}</td>
            <td>{props.request.hours}</td>
            <td>{props.request.rate}</td>
          </tr>
        </tbody>
      </Table>
      <DatePicker label="Date Paid" onChange={(event) => setDate(event.target.value)} />
    </RevShareModal>
  );
}

AcceptRequestModal.propTypes = {
  accept: PropTypes.func.isRequired,
  request: PropTypes.object.isRequired,
};
